const cloneSnapshot = (snapshot) => (
  snapshot ? JSON.parse(JSON.stringify(snapshot)) : null
);

const mapCustomizations = (customizations) => (
  (customizations || []).map((custom) => ({
    option_id: custom.option_id,
    option_name: custom.option_name,
    category_name: custom.category_name,
    selected_value: custom.selected_value,
    price_impact: custom.price_impact || 0,
  }))
);

const getLineItemCopyKey = (item, index) => (
  item.line_item_id || item.id || `idx-${index}`
);

export const getCopiedLineItemFabricHint = (item) => {
  const fabric = (item.customizations || []).find((custom) => (
    /fabric id/i.test(String(custom.option_name || ''))
  ));
  return fabric?.selected_value || '';
};

export const buildCopiedLineItems = (sourceItems, { mode = 'create' } = {}) => {
  const stamp = Date.now();
  return (sourceItems || []).map((item, index) => {
    const suffix = `${stamp}-${index}`;
    const copied = {
      product_id: item.product_id,
      product_name: item.product_name,
      garment_type: item.garment_type || item.product_name?.toLowerCase(),
      is_test_garment: !!item.is_test_garment,
      production_factory_id: item.production_factory_id || null,
      dispatch_factory_id: item.dispatch_factory_id || item.production_factory_id || null,
      quantity: item.quantity || 1,
      base_price: item.base_price || 0,
      customization_price_impact: item.customization_price_impact || 0,
      line_item_price: item.line_item_price || item.base_price || 0,
      customizations: mapCustomizations(item.customizations),
      snapshot_customization_schema: cloneSnapshot(item.snapshot_customization_schema),
    };

    if (mode === 'edit') {
      return {
        ...copied,
        line_item_id: `LI-${suffix}-${Math.random().toString(36).slice(2, 8)}`,
        _needs_garment: true,
        _is_test: !!item.is_test_garment || !!item._is_test,
      };
    }

    return {
      ...copied,
      id: `copied-${suffix}`,
    };
  });
};

export { getLineItemCopyKey };
